const CATALOG_URL = '/sponsors/sponsors.json';
const RESULTS_PATH_PREFIX = '/new-resultats-equipes';

let catalogCache = null;

function parseIsoDate(iso) {
	if (!iso) return null;
	const d = new Date(`${iso}T12:00:00`);
	return Number.isNaN(d.getTime()) ? null : d;
}

function isBannerActive(banner, today = new Date()) {
	const from = parseIsoDate(banner.activeFrom) ?? new Date(0);
	const until = parseIsoDate(banner.activeUntil) ?? new Date(8640000000000000);
	const t = today.getTime();
	if (t < from.getTime() || t > until.getTime()) return false;
	return (banner.weight ?? 0) > 0;
}

/** Sponsors : interface moderne des résultats. */
export function isResultsRoute(pathname) {
	return pathname === '/new-resultats-equipes';
}

export async function loadSponsorsCatalog() {
	if (catalogCache) return catalogCache;
	const response = await fetch(CATALOG_URL);
	if (!response.ok) {
		throw new Error(`Impossible de charger ${CATALOG_URL} (HTTP ${response.status})`);
	}
	catalogCache = await response.json();
	return catalogCache;
}

export function getActiveBanners(catalog, today = new Date()) {
	return (catalog?.banners ?? []).filter((banner) => isBannerActive(banner, today));
}

/** Tirage aléatoire pondéré (champ weight = ancienne colonne ponderation). */
export function pickWeightedBanner(catalog, today = new Date()) {
	const active = getActiveBanners(catalog, today);
	if (!active.length) return null;

	const totalWeight = active.reduce((sum, banner) => sum + banner.weight, 0);
	if (totalWeight <= 0) return null;

	let roll = Math.random() * totalWeight;
	for (const banner of active) {
		roll -= banner.weight;
		if (roll <= 0) return banner;
	}
	return active[active.length - 1];
}

export { RESULTS_PATH_PREFIX };
